import { hooks } from '@yola/ws-sdk';
import constants from '../constants';
import trackEvent from './track-event';

const handler = ({ blockId, variationId }) => {
  trackEvent(constants.events.BLOCK_COPIED, {
    targetBlockId: blockId,
    targetBlockVariationId: variationId,
  });
};

const trackBlockCopied = () => {
  hooks.operations.subscribe(hooks.availableHooks.ON_AFTER_BLOCK_COPIED, handler);
};

export default trackBlockCopied;
